import http from '../utils/http.js'
const project = 'sci/'

const pdfTools = {
  base64(data) {
    const url = project + 'pdf_tools/base64/encode'
    return http.get(url, { url: data }).then(res => {
      return res
    })
  }
}

export default pdfTools
